var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecord = function SvgRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "511pt",
    height: "511pt",
    viewBox: "0 -57 512 511"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.04 180.988c-7.782-12.547-21.532-20.047-36.782-20.047H129.695c-16.832 0-32.14 9.489-39.011 24.18L.87 373.43c3.39 13.789 16.27 24.09 31.61 24.09H393.75a40.75 40.75 0 0 0 36.46-22.555l77.63-155.594c6.129-12.312 5.45-26.66-1.8-38.383m0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.402 156.156c6.864-14.687 22.176-24.18 39.012-24.18h319.754V91.079c0-16.86-14.223-30.578-31.703-30.578H213.02c-.274 0-.461-.07-.532-.121l-33.37-46.66C173.206 5.44 163.444.5 153.015.5H31.71C14.223.5 0 14.219 0 31.078v276.875zm0 0"
  })));
};
export default SvgRecord;